import { OrderStatus, OrderType } from './common';

export const OrderStatusKr:Record<OrderStatus, string> = {
    NEW: '결제완료',
    PREPARING: '주문확인',
    READY: '제조완료',
    DONE: '픽업완료',
    CANCELLED: '주문취소',
    FAILED: '결제실패',
    UNKNOWN: '알수없음',
};

export const OrderStep: Record<OrderStatus, number> = {
    NEW: 0,
    PREPARING: 1,
    READY: 2,
    DONE: 3,
    CANCELLED: -1,
    FAILED: -1,
    UNKNOWN: -1,
};

export const OrderTypeKr: Record<OrderType, string> = {
    IN_SHOP: '매장',
    TAKE_OUT: '포장',
};
